// 核心优势
import { RootObject, CoreStrengthsModule, ContentList } from '../../type';
import './style.less';

const CoreStrengths = (props: RootObject["coreStrengths"]) => {
  return (
    <div className="core_strengths">
      <div className="core_strengths_title">
        {props.coreStrengthsTitle ?? ""}
      </div>
      <div className="core_strengths_module">

        {
          props.coreStrengthsModule.map((value: CoreStrengthsModule, index: number) => {
            return (
              <div className="module" key={index}>
                <img className="module_img" src={value.partnerList} alt=""/>
                <div className="moudle_des">
                  <div className="des_title">
                    {value.title ?? ""}
                  </div>
                  <div className="des_ul">
                  {
                      value.contentList.map((contentValue:ContentList,keys:number)=>{
                        return  ( 
                        <div className="des_li" key={keys}>
                        <span></span>
                        <span>
                        {contentValue.title}
                        </span>
                      </div>)
                      })
                    }
                   
                  </div>
                </div>
              </div>)
          })
        }
      </div>

    </div>
  )
}

export default CoreStrengths;